import { useState } from "react";
import api from "@/lib/api";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Loader2 } from "lucide-react";

const cache = {};

export const InvoiceHoverPreview = ({ inv, children }) => {
  const [p, setP] = useState(cache[inv.id] || null);
  const load = async (open) => {
    if (!open || p) return;
    try {
      const res = await api.get(`/invoices/${inv.id}/file`, { responseType: "blob" });
      const v = { url: URL.createObjectURL(res.data), type: res.data.type || inv.file?.content_type || "" };
      cache[inv.id] = v; setP(v);
    } catch { setP({ error: true }); }
  };
  return (
    <HoverCard openDelay={350} closeDelay={100} onOpenChange={load}>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent side="left" className="h-[480px] w-[380px] p-1" data-testid={`invoice-preview-${inv.id}`}>
        {!p ? <div className="flex h-full items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
          : p.error ? <div className="p-4 text-xs text-muted-foreground">Preview not available — click View.</div>
          : p.type.startsWith("image/") ? <img src={p.url} alt="Invoice" className="h-full w-full object-contain" />
          : <iframe src={`${p.url}#toolbar=0&navpanes=0&view=FitH`} title="Invoice preview" className="h-full w-full" />}
      </HoverCardContent>
    </HoverCard>
  );
};
